// JOBE-0162.2: OrganizationFilters — type pill row + department pill row.
// Both rows consume <PillChip /> from JOBE-0158.3. Department pill set is
// derived from the data — no hardcoded list. Spec: JOBE-0162.2 §"OrganizationFilters".

import React from 'react';
import { PillChip } from '../components/PillChip/PillChip.jsx';

const TYPE_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'human', label: 'Humans' },
  { value: 'agent', label: 'Agents' },
];

function titleCase(slug) {
  if (!slug) return '';
  return slug
    .split(/[-_\s]+/)
    .map((p) => (p.length === 0 ? '' : p.charAt(0).toUpperCase() + p.slice(1)))
    .join(' ');
}

/**
 * @param {object} props
 * @param {Array<{type:string,dept:string}>} props.rows
 * @param {string} props.typeFilter
 * @param {string} props.deptFilter
 * @param {(next:string)=>void} props.onTypeChange
 * @param {(next:string)=>void} props.onDeptChange
 */
export function OrganizationFilters({
  rows,
  typeFilter,
  deptFilter,
  onTypeChange,
  onDeptChange,
}) {
  const deptSet = new Set((rows || []).map((r) => r.dept).filter(Boolean));
  const depts = [...deptSet].sort();

  return (
    <div className="organization-filters" data-testid="organization-filters">
      <div
        className="organization-filters__row organization-filters__row--type"
        data-testid="organization-filters-type"
        data-label="Show"
      >
        {TYPE_OPTIONS.map((opt) => (
          <PillChip
            key={opt.value}
            label={opt.label}
            active={typeFilter === opt.value}
            onClick={() => onTypeChange(opt.value)}
          />
        ))}
      </div>
      <div
        className="organization-filters__row organization-filters__row--dept"
        data-testid="organization-filters-dept"
        data-label="Dept"
      >
        <PillChip
          key="all"
          label="All"
          active={deptFilter === 'all'}
          onClick={() => onDeptChange('all')}
        />
        {depts.map((d) => (
          <PillChip
            key={d}
            label={titleCase(d)}
            active={deptFilter === d}
            onClick={() => onDeptChange(d)}
          />
        ))}
      </div>
    </div>
  );
}
